import { Button } from "@devhop/ui";
import { PlusIcon } from "lucide-react";

type BookingsToolbarProps = {
  canManage?: boolean;
  onCreate: () => void;
  onBulkCreate?: () => void;
};

export function BookingsToolbar({
  canManage,
  onCreate,
  onBulkCreate,
}: BookingsToolbarProps) {
  return (
    <div className="mb-2 flex flex-wrap items-center justify-between space-y-2">
      <div>
        <h2 className="flex items-center font-bold text-2xl tracking-tight">
          ການຈອງຮຽນສ່ວນຕົວ
        </h2>
        <p className="text-muted-foreground">
          ຈັດການການຈອງຮຽນສ່ວນຕົວໃນລະບົບ.
        </p>
      </div>
      {canManage && (
        <div className="flex flex-wrap items-center gap-2">
          {onBulkCreate && (
            <Button type="button" variant="outline" onClick={onBulkCreate}>
              ຈອງຫຼາຍຄັ້ງ
            </Button>
          )}
          <Button onClick={onCreate}>
            <PlusIcon className="h-4 w-4" />
            ສ້າງການຈອງ
          </Button>
        </div>
      )}
    </div>
  );
}
